export default __webpack_public_path__ + "static/media/sevenWalkThumb.b4e141c3.png";